// פתקים — the pinboard. A note one person leaves for another, or for themselves.
//
// Its own part file, owning the single top-level key `notes`, which no other part claims
// (he.snapshot.test.js asserts that). A pure data module: no imports, so errors.js can
// never cycle back through it.
const notes = {
  nav: 'פתקים',
  title: 'פתקים',

  // The toggle. "שלי" is what is ADDRESSED TO ME — my board, including the notes I left
  // myself. "של כולם" is every note on the system, whoever wrote it and whoever it is
  // for. Deliberately not the calendar's "של שנינו": that screen belongs to two partners,
  // this board is open to the whole staff.
  mine: 'שלי',
  all: 'של כולם',

  newNote: 'פתק חדש',
  editNote: 'עריכת פתק',

  noteTitle: 'כותרת',
  noteBody: 'תוכן',
  bodyPlaceholder: 'מה צריך לזכור?',

  // Whose board it lands on. The picker opens on you, so a note to yourself needs no
  // decision at all.
  forUser: 'עבור',
  forMe: (name) => `${name} (אני)`,

  // The two facts a card carries besides its words: who it is for, and who wrote it.
  // "מאת" is shown on every card — on a shared board, who said it is half the message.
  from: 'מאת',
  to: 'עבור',
  // Beside the date, only on a note that was actually changed after it was written.
  edited: 'נערך',

  deleteNote: 'מחיקת פתק',
  deleteConfirm: (title) => `למחוק את הפתק "${title}"? הפעולה אינה הפיכה.`,

  // Two different kinds of nothing, exactly as היום שלי distinguishes them: an empty
  // board of my own is not the same fact as an empty board altogether.
  emptyMine: 'אין פתקים עבורכם.',
  emptyAll: 'אין פתקים עדיין.',
};

export default { notes };
